import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { saveOrderDetails } from "../../services/services";

export const saveOrder = createAsyncThunk(
  "costBreakdown/saveOrder",
  async (data) => {
    const response = await saveOrderDetails(data);
    if (response.status) {
      throw new Error("Something went wrong! Try again later."); // Explicitly throw the error
    }
    return response;
  }
);

const initialState = {
  orderDetails: null,
  loading: false,
  error: null,
};

const costBreakdownSlice = createSlice({
  name: "costBreakdown",
  initialState,
  reducers: {
    resetOrderDetails: (state) => {
      state.orderDetails = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveOrder.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveOrder.fulfilled, (state, action) => {
        state.orderDetails = action.payload;
        state.loading = false;
      })
      .addCase(saveOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetOrderDetails } = costBreakdownSlice.actions;

export default costBreakdownSlice.reducer;
